import { StandAloneRefund } from '../../dto/order/stand-alone-order-entry.dto';


export interface ISaveStandAloneOrderParam {
  date: string,
  orderId: number,
  posDeviceId: number,
  processingFee?: number,
  discountAmount?: number,
  serviceChargeAmount?: number,
  lastModifiedUserId: number,
  isProduct: boolean,
  isRefund: boolean
}

export interface ISaveStandAloneRefundOrderParam {
  date: string,
  refund: StandAloneRefund,
  posDeviceId: number,
  merchantPaymentMethodId: number,
  defaultProductId: number,
  lastModifiedUserId: number,
  isProduct: boolean,
}